"use client";

import * as React from "react";
import { Quote } from "lucide-react";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  name: "Ana Martínez",
  role: "Diseñadora Gráfica",
  content: "Llevaba años sintiéndome bloqueada en mi carrera creativa. Guillermo me ayudó a identificar mis propios obstáculos y a superarlos con herramientas prácticas. Ahora disfruto de mi trabajo con una claridad que no tenía antes.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1512785/img/testimonial_ana_martinez.png",
  initials: "AM"
}, {
  id: 2,
  name: "Carlos Ruiz",
  role: "Arquitecto",
  content: "La ansiedad por el futuro no me dejaba avanzar en mis proyectos personales. Las sesiones me dieron la calma y la estrategia mental que necesitaba para tomar decisiones con confianza y sin miedo al error.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1512785/img/testimonial_carlos_ruiz.png",
  initials: "CR"
}, {
  id: 3,
  name: "Laura Gómez",
  role: "Emprendedora Digital",
  content: "Pensaba que mi problema era la falta de tiempo, pero descubrí que era falta de foco. Gracias al coaching, he recuperado el control de mi agenda y, lo más importante, de mi paz mental.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1512785/img/testimonial_laura_gomez.png",
  initials: "LG"
}];
export default function HistoriasRealesDeClaridad() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}